import React from 'react';

export default function ErrorMessage({display, msg=''})
{
    let tmp = msg || 'Wrong credentials';
    if(display) return (<span>{tmp}</span>)
    return <></>
}